"use client";

import React from "react";

export default function ImageGalleryCardSkeleton({ variant = 'default' }: { variant?: 'default' | 'light' }) {
  const isLight = variant === 'light';
  return (
    <div
      className={
        "py-2 flex flex-col gap-1 rounded-2xl border border-zinc-200/60 dark:border-zinc-800 overflow-hidden shadow-sm animate-pulse " +
        (isLight ? "bg-white text-zinc-900" : "bg-card text-card-foreground")
      }
    >
      {/* Header area to match CardHeader */}
      <div className="px-4 pt-2">
        <div className="min-h-[56px] flex flex-col justify-between py-2">
          <div className="h-5 w-2/3 skeleton rounded" />
          <div className="h-4 w-1/2 skeleton rounded" />
        </div>
      </div>
      {/* Thumbnails grid with fixed total height (matches card h-[192px]) */}
      <div className="px-4 pb-4">
        <div className="relative grid grid-cols-3 gap-1 h-[192px] rounded-[inherit] overflow-hidden items-stretch">
          {Array.from({ length: 3 }).map((_, i) => (
            <div key={i} className="h-full w-full rounded-lg skeleton" />
          ))}
        </div>
      </div>
      {/* Footer date area */}
      <div className="px-4 pb-3">
        <div className="h-3 w-24 skeleton rounded" />
      </div>
    </div>
  );
}
